exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".answered-toggle-container{display:flex;justify-content:flex-end;color:#b1cbd8;font-size:13px}", ""]);

// exports
